const OnEscape = function (ev) {
  if (ev.keyCode === 27) {
    this.addUser.hideModal()
  }
}

export default OnEscape
